import React from "react";
import InfoTooltip from "components/Common/InfoTooltip";
import classNames from "classnames";
import "./style.scss";

class ReadOnlyInput extends React.Component {
  constructor(props) {
    super(props);
    this.copyValue = this.copyValue.bind(this);
    this.onClickCopyButton = this.onClickCopyButton.bind(this);
    this.state = {
      tooltipOpen: false
    };
  }

  onClickCopyButton() {
    this.copyValue();
    this.setState({
      tooltipOpen: true
    }, () => setTimeout(
      () => this.setState({ tooltipOpen: false }),
      1000
    ));
  }

  /**
   */
  copyValue() {
    this.input.select();
    document.execCommand("copy");
  }

  render() {
    return (
      <div
        className={classNames("ReadOnlyInput", {
          [this.props.customClassName]: this.props.customClassName
        })}
      >
        <input
          className={classNames("g-input ReadOnlyInput__input", {
            [this.props.className]: this.props.className
          })}
          id={this.props.idForLabel}
          value={this.props.value}
          type="text"
          placeholder={this.props.placeholder}
          autoComplete="off"
          spellCheck={false}
          onClick={() => this.input.select()}
          ref={(input) => {
            this.input = input;
          }}
          readOnly
        />
        {/* Not going to have a keyboard handler */}
        <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, max-len
          role="button"
          className="ReadOnlyInput__search-icon-container"
          onClick={this.onClickCopyButton}
        >
          <InfoTooltip
            blurb="Copied"
            iconDefault="Copy"
            iconClicked="Copy"
            absolute
            opened={this.state.tooltipOpen}
            customClassName="Tooltip--copied"
          />
        </div>
      </div>
    );
  }
}

export default ReadOnlyInput;
